<!--
  Общая SVG-иконка секций ЭДО.
  Даёт форме заполнения и read-only просмотру один источник визуальных значков.
-->
<template>
  <svg
    :viewBox="viewBox"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    v-html="iconPath"
  />
</template>

<script>
const SECTION_ICONS = {
  source: '<path d="M3 5h18v14H3z"/><path d="M7 9h10M7 13h6"/>',
  document: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8M8 17h6"/>',
  participants: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  route: '<path d="M12 22s7-6.2 7-13a7 7 0 0 0-14 0c0 6.8 7 13 7 13z"/><circle cx="12" cy="9" r="2.5"/>',
  loading: '<path d="M12 15V3m0 12-4-4m4 4 4-4"/><path d="M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"/>',
  cargo: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7L12 12l8.7-5"/><path d="M12 22V12"/>',
  conditions: '<path d="M15 14.76V5C15 3.34 13.66 2 12 2S9 3.34 9 5v9.76A5 5 0 1 0 15 14.76Z"/><path d="M12 6v12"/>',
  vehicle: '<path d="M10 17h4V5H2v12h3"/><path d="M14 8h4l4 4v5h-3"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>',
  payment: '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><path d="M6 15h4"/>',
  preview: '<path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>',
  signature: '<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
};

export default {
  name: "EdoSectionIcon",

  props: {
    name: {
      type: String,
      default: "document",
    },
  },

  computed: {
    iconPath() {
      return SECTION_ICONS[this.name] || SECTION_ICONS.document;
    },

    viewBox() {
      return this.name === "cargo" ? "0 0 24 25" : "0 0 24 24";
    },
  },
};
</script>

<style scoped>
svg {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
</style>
